var NewsletterSignup_1;
import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { Task } from '@lit/task';
import { NewsletterService } from '../services/newsletter-service.js';
import { componentStyles } from './newsletter-signup.css.js';
let NewsletterSignup = NewsletterSignup_1 = class NewsletterSignup extends LitElement {
    constructor() {
        super(...arguments);
        this._newseletterService = new NewsletterService(new URL(`${window.location.origin}/wp-json/ballerleague-content-hub/v1/newsletter`));
        this._formData = new FormData();
        this._formSubmissionTask = new Task(this, {
            task: async ([emailAddress]) => {
                this._formData.set('email', emailAddress);
                return this._newseletterService.register(emailAddress);
            }
        });
    }
    get emailAddress() {
        const emailField = this.shadowRoot?.querySelector('input[type="email"]');
        if (emailField === null || emailField === undefined) {
            return '';
        }
        else {
            return emailField.value;
        }
    }
    render() {
        return html `
    ${this._formSubmissionTask.render({
            initial: () => this._renderInitialView(),
            pending: () => this._renderPendingView(),
            error: (error) => this._renderErrorView(error),
            complete: () => this._renderSuccessView()
        })}
    `;
    }
    _onFormSubmission(event) {
        event.preventDefault();
        this._formSubmissionTask.run([this.emailAddress]);
    }
    _renderInitialView() {
        this.setAttribute('screen', 'initial');
        // Set the placeholder email value
        this._formData.set('email', "muster@mail.com");
        return html `
    <div>
      <h3>${NewsletterSignup_1.uiStrings.formHeadline}</h3>
      <p>${NewsletterSignup_1.uiStrings.formText}</p>
    </div>
    
    <form @submit=${this._onFormSubmission}>
      <input type="email" placeholder=${this._formData.get('email')} />
      <button type="submit">${NewsletterSignup_1.uiStrings.submitButton}</button>
    </form>
    `;
    }
    _renderPendingView() {
        this.setAttribute('screen', 'pending');
        return html `
    <div>
      <h3>${NewsletterSignup_1.uiStrings.formHeadline}</h3>
      <p>${NewsletterSignup_1.uiStrings.formText}</p>
    </div>
    <form>
      <input type="email" value=${this._formData.get('email')} disabled />
      <button type="submit" disabled>${NewsletterSignup_1.uiStrings.submitButton}</button>
    </form>
    `;
    }
    _renderErrorView(error) {
        const errorMessage = this._determineErrorString(error);
        this.dispatchEvent(new CustomEvent('newsletter-signup-failed', { bubbles: true, composed: true, detail: error }));
        this.setAttribute('screen', 'error');
        return html `
    <div>
      <h3>${NewsletterSignup_1.uiStrings.formHeadline}</h3>
      <p>${NewsletterSignup_1.uiStrings.formText}</p>
    </div>
    <div>
      <form @submit=${this._onFormSubmission} data-errors="true">
        <input type="email" value=${this._formData.get('email')} />
        <button type="submit">${NewsletterSignup_1.uiStrings.submitButton}</button>
      </form>
      <div class="error-msg">${errorMessage}</div>
    </div>
    `;
    }
    _renderSuccessView() {
        this._formData.delete('email');
        this.setAttribute('screen', 'success');
        this.dispatchEvent(new CustomEvent('newsletter-signup-success', { bubbles: true, composed: true }));
        return html `
    <div>
      <h3>${NewsletterSignup_1.uiStrings.successHeadline}</h3>
      <p>${NewsletterSignup_1.uiStrings.successText}</p>
    </div>
    <svg width="142" height="131" viewBox="0 0 142 131" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M103.796 0C88.8205 0 75.8471 8.73571 69.6881 21.3679L25.2644 10.7917L21.8707 9.98366L18.6386 9.21154L17.7767 12.8477L16.9866 16.1786L1.66095 80.4888L0.870877 83.8107L0 87.4379L3.25008 88.21L6.65278 89.018L16.1247 91.2715L14.4637 98.1039L39.1625 104.083L37.8607 109.443L65.8904 116.231V130.443H141.72V37.9146C141.711 17.0135 124.706 0 103.796 0Z" fill="white"/>
      <path d="M103.796 4.4873C122.255 4.4873 137.221 19.4538 137.221 37.9128V125.961H70.3701V37.9128C70.3701 19.4538 85.3366 4.4873 103.796 4.4873Z" fill="#1D2124"/>
      <path d="M126.153 39.8895L22.2891 15.1621L5.95384 83.7757L109.817 108.503L126.153 39.8895Z" fill="white" stroke="#1D2124" stroke-width="0.897811" stroke-miterlimit="10"/>
      <path d="M22.2891 15.1704L63.2203 73.7257L126.157 39.8961" stroke="#1D2124" stroke-width="0.897811" stroke-miterlimit="10"/>
      <path d="M79.7852 65.1631L109.817 108.509" stroke="#1D2124" stroke-width="0.897811" stroke-miterlimit="10"/>
      <path d="M5.95117 83.7772L52.4398 58.5308" stroke="#1D2124" stroke-width="0.897811" stroke-miterlimit="10"/>
      <path d="M47.4358 71.1503C55.6123 71.1503 62.2407 64.522 62.2407 56.3454C62.2407 48.1689 55.6123 41.5405 47.4358 41.5405C39.2592 41.5405 32.6309 48.1689 32.6309 56.3454C32.6309 64.522 39.2592 71.1503 47.4358 71.1503Z" fill="#00D296" stroke="#1D2124" stroke-width="0.897811" stroke-miterlimit="10"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M42.3917 52.14C40.4704 51.8078 38.6029 52.3555 37.1934 53.4957C38.1271 55.04 39.6983 56.1982 41.6196 56.5303C43.5409 56.8625 45.4083 56.3149 46.8179 55.1746C45.8842 53.6304 44.313 52.4812 42.3917 52.14Z" fill="white" stroke="#1D2124" stroke-width="0.897811" stroke-miterlimit="10"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M53.6143 54.1044C51.693 53.7722 49.8256 54.3199 48.416 55.4601C49.3497 57.0043 50.9209 58.1625 52.8422 58.4947C54.7635 58.8269 56.631 58.2792 58.0406 57.139C57.1068 55.5948 55.5357 54.4456 53.6143 54.1044Z" fill="white" stroke="#1D2124" stroke-width="0.897811" stroke-miterlimit="10"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M39.7521 52.3636C39.2493 52.2739 38.7645 52.4445 38.4144 52.7677L37.1934 53.4949L38.0104 54.3747C38.181 54.9045 38.6299 55.3264 39.2134 55.4342C40.0574 55.5868 40.8654 55.0122 41.018 54.1682C41.1617 53.3153 40.5961 52.5073 39.7521 52.3636Z" fill="#1D2124"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M50.9748 54.335C50.454 54.2452 49.9513 54.4248 49.6101 54.7659L49.4485 54.739L48.416 55.4662L48.847 56.3281L49.3408 56.6244V56.6154C49.5652 57.0105 49.9423 57.3157 50.4271 57.3965C51.2711 57.5492 52.0791 56.9745 52.2317 56.1306C52.3933 55.2867 51.8277 54.4786 50.9748 54.335Z" fill="#1D2124"/>
      <path d="M48.8114 60.1831C48.6139 61.3233 47.5276 62.0865 46.3874 61.8889C45.2471 61.6914 44.484 60.6051 44.6815 59.4648" stroke="#1D2124" stroke-width="0.897811" stroke-miterlimit="10"/>
      <path d="M19.9873 94.3721L63.998 105.029" stroke="#1D2124" stroke-width="0.897811" stroke-miterlimit="10"/>
      <path d="M66.4995 111.316L43.3809 105.714" stroke="#1D2124" stroke-width="0.897811" stroke-miterlimit="10"/>
    </svg>
    `;
    }
    _determineErrorString(error) {
        // TODO: Figure out how to actually implement this
        console.error(error);
        let isFixable = true;
        if (isFixable) {
            return NewsletterSignup_1.uiStrings.solvableError;
        }
        else {
            return NewsletterSignup_1.uiStrings.unsolvableError;
        }
    }
};
NewsletterSignup.styles = componentStyles;
NewsletterSignup.uiStrings = {
    formHeadline: 'Bleib am Ball!',
    formText: 'Natürlich halte wir Dich auch gern ganz old school per Newsletter auf dem Laufenden.',
    submitButton: 'Schick ihn',
    successHeadline: 'Sauber!',
    successText: 'Wir halten Dich per Newsletter auf dem Laufenden.',
    solvableError: 'Check nochmal ob alle Eingaben stimmen.',
    unsolvableError: 'Es gibt gerade ein Problem. Versuch es später nochmal.'
};
NewsletterSignup = NewsletterSignup_1 = __decorate([
    customElement('newsletter-signup')
], NewsletterSignup);
export { NewsletterSignup };
//# sourceMappingURL=newsletter-signup.js.map